var _linearGradient, _circle, _circle2, _circle3, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearColors"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#30E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F04FB4"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 99,
    cx: 838,
    cy: 287,
    fill: "none",
    stroke: "url(#linearColors)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "60s",
    repeatCount: "indefinite",
    path: "M0,0 a99,99 0 1,0 -198,0 a99,99 0 1,0 198,0 z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 21,
    cx: 87,
    cy: 20,
    fill: "none",
    stroke: "url(#linearColors)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "40s",
    repeatCount: "indefinite",
    path: "M0,0 a21,21 0 1,0 42,0 a21,21 0 1,0 -42,0 z"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 40,
    cx: 556,
    cy: 260,
    fill: "none",
    stroke: "url(#linearColors)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "40s",
    repeatCount: "indefinite",
    path: "M0,0 a40,40 0 1,0 -80,0 a40,40 0 1,0 80,0 z"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 32,
    cx: 151,
    cy: 372,
    fill: "none",
    stroke: "url(#linearColors)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "20s",
    repeatCount: "indefinite",
    path: "M0,0 a32,32 0 1,0 64,0 a32,32 0 1,0 -64,0 z"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 60,
    cx: 537,
    cy: 549,
    fill: "none",
    stroke: "url(#linearColors)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "20s",
    repeatCount: "indefinite",
    path: "M0,0 a60,60 0 1,0 -120,0 a60,60 0 1,0 120,0 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.4a5f607d1b5e7366452a3ab1544d946c.svg";
export { ForwardRef as ReactComponent };